import React, { memo } from "react";
import { MuiThemeProvider } from "@material-ui/core";
import { Switch, Route } from "react-router-dom";
import AppSnackbar from "components/AppSnackbar";
import ServiceWorkerWrapper from "components/ServiceWorkerWrapper";
import NetworkToolbar from "components/NetworkToolbar";
import useAppHooks from "./index.hooks";
import {
  LoginPage,
  SignUpPage,
  LandingPage,
  FaqPage,
  Dashboard,
  MerchantsOverview,
} from "scenes";

const App: React.FC = () => {
  const { theme } = useAppHooks();

  return (
    <MuiThemeProvider theme={theme}>
      <ServiceWorkerWrapper />
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/signup" component={SignUpPage} />
        <Route exact path="/faq" component={FaqPage} />
        <Route exact path="/merchants" component={MerchantsOverview} />
        <Route path="/merchants/:merchantId" component={Dashboard} />
      </Switch>
      <AppSnackbar />
      <NetworkToolbar />
    </MuiThemeProvider>
  );
};

export default memo(App);
